
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ChevronUp } from 'react-feather'

const StyledDiv = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 64px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  bottom: 30px;
  right: 30px;
  z-index: 20;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }

  @media (max-width: 800px) {
    height: 45px;
    width: 45px;
    bottom: 90px;
    right: 20px;
  }
`

const ArrowUpStyled = styled(ChevronUp)`
  height: 65%;
  width: 65%;
  color: rgba(255, 255, 255, 0.3);
  fill: none;
`

// Scroll up button for affiliates page - can be added to rest of the pages too
export default function ScrollUp() {
  const scrollToTop = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
  }

  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const scrollFunction = () => {
      if (window.pageYOffset > 300) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    }
    window.addEventListener("scroll", scrollFunction)
    return () => {
      window.removeEventListener("scroll", scrollFunction)
    }
  }, [])

  return (
    <>
      {showButton && <StyledDiv onClick={scrollToTop}>
        <ArrowUpStyled />
      </StyledDiv>}
    </>
  )
}
